import * as cn from "classnames";
import * as React from "react";

export interface AutoFitSvgProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
    svgContent: string;

    onProcessSvg?: (svg: SVGElement) => void;
}

export class AutoFitSvg extends React.Component<AutoFitSvgProps> {
    render() {
        const { className, svgContent, onProcessSvg, ...svgProps } = this.props;

        return (
            <svg
                {...svgProps}
                className={cn(className)}
                preserveAspectRatio="xMidYMid meet"
                ref={svg => this.setSvg(svg)}
                dangerouslySetInnerHTML={{ __html: svgContent }}
            />
        );
    }

    private setSvg(svg: SVGSVGElement | undefined) {
        if (svg) {
            const bbox = svg.getBBox();
            svg.setAttribute("viewBox", `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`);

            this.props.onProcessSvg && this.props.onProcessSvg(svg);
        }
    }
}
